import { Quote } from "../../quote.type";

export class QuoteLocationSurchargeBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    public name: string,
    public internalNote: string,
    public quote: Quote,
  ) {}

  public getId(): number {
    return this.id;
  }
  public getDiscriminator(): string {
    return this.discriminator;
  }

  public getName(): string {
    return this.name;
  }

  public setName(name: string): void {
    this.name = name;
  }

  public getInternalNote(): string {
    return this.internalNote;
  }

  public setInternalNote(internalNote: string): void {
    this.internalNote = internalNote;
  }

  public getQuote(): Quote {
    return this.quote;
  }

  public setQuote(quote: Quote) {
    this.quote = quote;
  }
}
